import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";
import { categoryModel } from "@/models/categoryModel";
import { mediaType } from "@/models/mediaModel";
import { facetModel } from "@/models/facetModel";
import baseUserContextComponent from "../baseUserContextComponent";
@Component({})
export default class categoryExpandFilter extends baseUserContextComponent {
    @Prop({ default: () => [] })
    categories: categoryModel[];
    @Prop({ default: () => null })
    categoryId: number;

    @Prop({ default: () => "" })
    title: string | null;
    @Prop({ default: () => "" })
    cssClass: string | null;
    @Prop({ default: () => [] })
    facets: facetModel[] | null;
    @Prop({ default: () => [] })
    facetsForCount: facetModel[] | null;
    @Prop({ default: () => true })
    showCount: boolean;

    visible: boolean = true;
    get showCategories() {
        return this.categories != null && this.categories.length > 0;
    }
    get visibleRootCategories() {
        var rootCategories = this.groupByParentId();
        console.log(rootCategories);

        return rootCategories;
    }

    get visibleCategories() {
        var cats = [];

        for (var i = 0; i < this.categories.length; i++) {
            var c = this.categories[i];
            if (this.getCountAgg(c) > 0) {
                cats.push(c);
            }
        }

        return cats;
    }
    getCount(c: categoryModel): number | null {
        var instance = this;
        if (instance.facets == null || c == null) return 0;
        var f = instance.facets.find((x) => x.code == "CategoryId");
        if (f == null) return 0;
        var count = f.values[c.id];
        return count != null ? count : 0;
    }
    getCountAgg(c: categoryModel): number | null {
        var instance = this;
        if (instance.facetsForCount == null || c == null) return 0;
        var f = instance.facetsForCount.find((x) => x.code == "CategoryId");
        if (f == null) return 0;
        var count = f.values[c.id];
        return count != null ? count : 0;
    }
    onClick(c: categoryModel) {
        this.$emit("select", c);
    }

    // get subCategoriesSorted(): categoryModel[] {
    //   var instance = this;
    //   var cat = [];
    //   if (instance.categories) {
    //     cat = instance.categories.sort((a, b) => (a.displayOrder > b.displayOrder ? 1 : -1));
    //   }
    //   return cat;
    // }

    getPropery(category: categoryModel, property: string) {
        if (category == null || category.locales == null) return "";
        var l = category.locales["it-IT"];
        return l == null ? "" : l[property];
    }
    getImageUrl(category: categoryModel) {
        if (category == null || category.media == null || category.media.length == 0) return null;

        var media = category.media
            //.sort((a, b) => (a.displayOrder > b.displayOrder ? 1 : -1))
            .find((x) => x.mediaType == mediaType.Image && x.languageId == "it-IT");

        return media == null ? null : media.path;
    }

    groupByParentId() {
        let catsgrouped = [];

        for (var i = 0; i < this.visibleCategories.length; i++) {
            let c = this.visibleCategories[i];
            if (catsgrouped.some(item => item.id == c.parents[0].id ) == false) {
                c.children = [];
                catsgrouped.push(c.parents[0]);
            }
        }

        console.log(catsgrouped);

        for (var i = 0; i < catsgrouped.length; i++) {
            let c = catsgrouped[i] as any;

            let children = this.visibleCategories.filter(item => {
                return item.parents[0].id == c.id;
            })

            c.children = children;
        }

        return catsgrouped;
    }

    onShow(rootId) {
        var rightIcon = `#cat-exp-icon-right-${rootId}`;
        var downIcon = `#cat-exp-icon-down-${rootId}`;

        $(rightIcon).show();
        $(downIcon).hide();
    }

    onHide(rootId) {
        var rightIcon = `#cat-exp-icon-right-${rootId}`;
        var downIcon = `#cat-exp-icon-down-${rootId}`;

        $(downIcon).show();
        $(rightIcon).hide();
    }
}
